import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Assignments Management
const TenantAdminSelectIslandPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-management/pages/tenant-admin-select-island"
    )
);
const AddAssignmentPage = lazy(
  () => import("@quest/shared/assignment/components/create-assignment")
);
const AssignmentListPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-management/pages/tenant-admin-assignment-list"
    )
);
const ViewAssignmentPage = lazy(
  () => import("@quest/shared/assignment/components/view-assignment")
);

const IslandsSubjectsListPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-management/pages/islands-subjects-list"
    )
);

export const assignmentsRoutes: RouteObject[] = [
  {
    path: "/admin/quest-management",
    element: (
      <RequirePermission resource="curriculum">
        <TenantAdminSelectIslandPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/quest-management/assignment-list/:id",
    element: (
      <RequirePermission resource="curriculum">
        <AssignmentListPage isDeleted={false} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/quest-management/add-assignment",
    element: (
      <RequirePermission resource="curriculum">
        <AddAssignmentPage isSuperadmin={false} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/quest-management/edit-assignment/:assignmentId",
    element: (
      <RequirePermission resource="curriculum">
        <AddAssignmentPage isSuperadmin={false} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/quest-management/assignment-list/view-assignment/:id",
    element: (
      <RequirePermission resource="curriculum">
        <ViewAssignmentPage isSuperAdmin={false} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/quest-management/deleted-assignment-list",
    element: (
      <RequirePermission resource="curriculum">
        <AssignmentListPage isDeleted={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/quest-management/subjects-list/:islandId",
    element: (
      <RequirePermission resource="curriculum">
        <IslandsSubjectsListPage />
      </RequirePermission>
    ),
  },
];
